import cssUtil from 'gw-portals-util-js/CssUtil';

import styles from './PropertyCode-hashed.scss';
import template from 'text!./PropertyCode.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            match: '=',
            query: '='
        },
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode.js
// module id = 83
// module chunks = 0